import requestStatus from '../../lib/constants/requestStatus';
import ReducersFactory from '../../lib/reducers/ReducersFactory';
import actionTypes from '../action/actionTypes';
import { RESULTS_DEFAULT } from '../constants/initStateItems';


const extraReducers = builder => {
    builder
      .addMatcher(
        (action) => action.type === actionTypes.MATRIX_RESULTS_REQUEST,
        (state, action) => ({
            ... RESULTS_DEFAULT,
            status: requestStatus.REQUEST_PENDING,
        })
      )
      .addMatcher(
        (action) => action.type === actionTypes.MATRIX_RESULTS_SUCCES,
        (state, action) => ({
            ... RESULTS_DEFAULT,
            results: action.payload.results,
            status: requestStatus.REQUEST_SUCCESS,
        })
      )
      .addMatcher(
        (action) => action.type === actionTypes.MATRIX_RESULTS_ERROR,
        (state, action) => ({
            status: requestStatus.REQUEST_ERROR,
            error: action.payload.error
        })
      )
}

const results = new ReducersFactory('results', [], RESULTS_DEFAULT, false, extraReducers)


export default results.reducer